<template>
  <div>
    <base-header class="pb-6" type="primary">
      <breadcrumb-header :items="breadcrumb"></breadcrumb-header>
    </base-header>

    <div class="container-fluid mt--6">
      <table-navigation :table-title="tableTitle"
                        :table-buttons="tableButtons"
                        :table-columns="tableColumns"
                        :table-data="tableData"
                        :router-view="routerView"
                        :connection-error="connectionError"
                        :pagination="pagination"
                        :filter-options="filterOptions"
                        :filters="tableFilters"
                        @page="changePage"
                        @filters="changeFilters"
      >
      </table-navigation>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
import TableNavigation from "@/views/Store/Tables/TableNavigation";
import BreadcrumbHeader from "@/views/Store/Layout/BreadcrumbHeader";

const {mapState, mapActions} = createNamespacedHelpers('PartnerListModule')

export default {
  name: 'PartnerList',
  components: {
    BreadcrumbHeader,
    TableNavigation,
  },
  data() {
    return {
      tableTitle: 'Lista partnerów',
      routerView: 'partner-view',
      tableButtons: [
        {
          label: 'Dodaj partnera',
          icon: 'fas fa-edit',
          link: 'partner-add',
        },
      ],
      tableColumns: [
        {
          prop: 'company',
          label: 'Nazwa',
          minWidth: 120,
          sortable: true,
          link: true,
        },
        {
          prop: 'fullName',
          label: 'Pełna nazwa',
          minWidth: 120,
          sortable: true,
          link: true,
        },
        {
          prop: 'code',
          label: 'Kod',
          minWidth: 80,
          sortable: true,
        },
        {
          prop: 'iln',
          label: 'EDI ILN',
          minWidth: 80,
          sortable: true,
        },
        {
          prop: 'active',
          label: 'Aktywny',
          minWidth: 60,
          sortable: false,
        },
      ],
      filterOptions: [
        {field: 'fullName', label: 'Pełna nazwa'},
        {field: 'company', label: 'Nazwa'},
        {field: 'code', label: 'Kod'},
        {field: 'iln', label: 'ILN'},
        {field: 'active', label: 'Aktywny'},
      ],
    }
  },
  computed: {
    ...mapState({
      tableData: state => state.items,
      totalItems: state => state.totalItems,
      tableFilters: state => state.filterValues,
      connectionError: state => state.apiConnectionErr
    }),
    breadcrumb() {
      return [
        {title: 'Klienci', link: {name: 'clients'}},
        {title: 'Partnerzy'},
      ];
    },
    handleError() {
      return `Błąd ${this.connectionError.status} - ${this.$t[this.connectionError.status]}`;
    },
    pagination() {
      return {
        totalItems: this.totalItems,
        perPage: 20,
        currentPage: parseInt(this.$route.params.pageNum || 1),
      };
    },
  },
  methods: {
    changePage(page) {
      this.$router.push({name: 'partner-list', params: {pageNum: page}});
    },
    changeFilters(filters) {
      this.$store.commit('PartnerListModule/setFilterValues', filters);
      this.$store.dispatch('PartnerListModule/fetchList', {
        token: this.$store.state.Auth.token,
        page: 1,
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('PartnerListModule/resetItems', []);
    return next()
  },
  beforeRouteUpdate(to, from, next) {
    this.$store.commit('PartnerListModule/resetItems', []);
    this.$store.dispatch('PartnerListModule/fetchList', {
      token: this.$store.state.Auth.token,
      page: to.params.pageNum || 1,
    });
    return next();
  },
  beforeCreate() {
    this.$store.dispatch('PartnerListModule/fetchList', {
      token: this.$store.state.Auth.token,
      page: this.$route.params.pageNum || 1,
    });
  },
};
</script>
